import React, { useRef, useEffect, useMemo, useState } from 'react';
import JSZip from 'jszip';
import * as d3 from 'd3';
import { Line, Sphere } from '@react-three/drei';
import * as THREE from 'three';

export default function PlannedHoles({ url, dataset ,color = 'red' ,visible }) {
    const [holeData, setHoleData] = useState([]);
    const constants_ = [0,0,0];

    useEffect(() => {
        const fetchData = async () => {
            const blob = await fetchDataWithProgress(url);
            console.log('Download complete. Extracting...');
            const zip = await JSZip.loadAsync(blob);
            const fileName = Object.keys(zip.files)[0]; // Assuming there's only one file in the zip
            const fileData = await zip.file(fileName).async('string');
            const parsedData = d3.csvParse(fileData);

            // Filter rows based on dataset and holetype, then order by Depth_From and holeID
            const filteredData = parsedData
                .filter(row => row.DataSet === dataset)
                .sort((a, b) => a.Hole_ID.localeCompare(b.Hole_ID));

            setHoleData(filteredData);
        };

        fetchData();
    }, [url, dataset]);

    

    return (
        <>
            <group visible={visible}>
                {holeData.map(hole => {
                    let start = [Number(hole.X) - constants_[0], Number(hole.Z) - constants_[2], Number(hole.Y)-constants_[1]]
                    let end = calculateEndCoordinates(start, hole.Azimuth, hole.Dip, hole.Depth)
                    const points = [
                        start,
                        end
                    ];

                    return (
                        <group key={hole.Hole_ID}>
                            <Sphere 
                                position={start}
                                args={[2, 16, 16]}
                                userData={{ displayData: hole}}
                                name={hole.Hole_ID}
                            >
                                <meshStandardMaterial color={"limegreen"} />
                            </Sphere>
                            <Line
                                points={points}
                                closed={false}
                                curveType="centripetal"
                                userData={{ displayData: hole}}
                                lineWidth={2}
                                color={color}
                                name={hole.Hole_ID}
                            />
                        </group>
                    );
                })}
            </group>
        </>
    );
}

const fetchDataWithProgress = async (url) => {
    const response = await fetch(url);
    const reader = response.body.getReader();
    const contentLength = +response.headers.get('Content-Length');

    let receivedLength = 0;
    const chunks = [];

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        receivedLength += value.length;

        console.log(`Received ${((receivedLength / contentLength) * 100).toFixed(2)}% of ${contentLength} bytes`);
    }

    return new Blob(chunks);
};

const calculateEndCoordinates = (start, direction, inclination, depth) => {

    const dirRad = (parseFloat(direction) * Math.PI) / 180;
    const incRad = (parseFloat(inclination) * Math.PI) / 180;
  
  
    const dx = depth * Math.abs(Math.cos(incRad)) * Math.sin(dirRad);
    const dy = depth * Math.sin(incRad)
    const dz = depth * Math.abs(Math.cos(incRad)) * Math.cos(dirRad);
  
    const coords = [
      start[0] + dx,
      start[1] + dy,
      start[2] - dz
    ];
  
    return coords
  };
  
  